import script from "./loginView.vue?vue&type=script&setup=true&lang=js"
export * from "./loginView.vue?vue&type=script&setup=true&lang=js"

import "./loginView.vue?vue&type=style&index=0&id=8243b1e4&lang=scss"

const __exports__ = script;

export default __exports__